import { Text } from '@mantine/core';
import { modals } from '@mantine/modals';
import i18n from '../i18n';

/**
 * Xavfli (o'chirish) amal uchun tasdiqlash modali.
 * Komponent emas — shuning uchun hook o'rniga i18n instansiyasi ishlatiladi
 * (modal ochilgan paytdagi joriy tilni oladi).
 */
export function confirmDelete(name: string, onConfirm: () => void) {
  modals.openConfirmModal({
    title: i18n.t('confirm.title'),
    centered: true,
    children: (
      <Text size="sm">
        <b>{name}</b> {i18n.t('confirm.msg')}
      </Text>
    ),
    labels: { confirm: i18n.t('confirm.ok'), cancel: i18n.t('confirm.cancel') },
    confirmProps: { color: 'red' },
    onConfirm,
  });
}
